import { render, staticRenderFns } from "./DraftExercises.vue?vue&type=template&id=4fabcb14&"
import script from "./DraftExercises.vue?vue&type=script&lang=js&"
export * from "./DraftExercises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports